import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { ModalContext } from '../../components/contexts';
import { isValidBrNo } from '../../services/UtilService'; // isValidBrNo 함수 import
import { NumericFormat } from 'react-number-format';
import { useNavigate, useLocation } from 'react-router-dom';
import { nlPost } from '../../apis/notLoginApi';

const EntJoinBRNO = () => {
  useEffect(() => {
    document.title = '기업 정보 조회';
  }, []);

  const { modalService } = useContext(ModalContext);
  const [formData, setFormData] = useState({
    brNo: '', // 사업자 등록번호 필드 추가
    brNoF: '', // 세 개의 필드가 나누어져 있어서 각각 받고 합침
    brNoS: '',
    brNoT: '',
  });
  const [brNoValid, setBrNoValid] = useState(false); // 사업자 등록번호 유효성 상태 추가
  const [brNoValidMsg, setBrNoValidMsg] = useState(''); // 사업자 등록번호 유효성 메시지 상태 추가
  const [dplChkBool, setDplChkBool] = useState(false); // 중복확인 결과 상태 추가

  const [mode, setMode] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.mode) {
      setMode(location.state.mode);
    }
  }, [location.state]);

  // input 입력 시 판별별
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => {
      const updatedFormData = {
        ...prevFormData,
        [id]: value,
      };
      const brNo = `${updatedFormData.brNoF}${updatedFormData.brNoS}${updatedFormData.brNoT}`;
      updatedFormData.brNo = brNo;

      if (isValidBrNo(brNo)) {
        setBrNoValid(true);
      } else {
        setBrNoValid(false);
      }

      return updatedFormData;
    });
  };

  // 사업자등록번호 중복확인
  const fnDplChk = () => {
    const url = '/member/duplicateBrnoChk.do';
    const param = {
      brNo: formData.brNo,
    };

    if (param.brNo != '') {
      nlPost(url, param)
        .then(response => {
          setDplChkBool(response);
          if (response instanceof Error) {
            this.modalService.errorAlert(
              '데이터 처리중 에러가 발생하였습니다',
              () => {}
            );
          } else {
            if (response == true) {
              setBrNoValidMsg('사용 불가능한 사업자 등록번호입니다.');
            } else if (response == false) {
              setBrNoValidMsg('사용 가능한 사업자 등록번호입니다.');
              handleLinkClick();
            }
            if (response == true) {
              modalService.errorAlert(
                '사용 불가능한 사업자 등록번호입니다.',
                () => {}
              );
            }
          }
        })
        .catch(error => {});
    }
  };

  useEffect(() => {}, [brNoValidMsg]);

  const handleLinkClick = () => {
    if (brNoValid && dplChkBool != true) {
      modalService.successAlert('사용 가능한 사업자 등록번호입니다.', () => {
        navigate('/member/joinTermsEnt', {
          state: { mode: mode, brNo: formData.brNo },
        });
      });
    } else {
      // alert('유효하지 않은 사업자 등록번호입니다.');
      modalService.errorAlert('유효하지 않은 사업자 등록번호입니다.', () => {});
    }
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 가입</h2>
      </div>

      <ol className="step-wrap">
        <li className="done">
          <span>
            <i className="sr-only">1단계</i>
            <span className="step-tit">가입 유형 선택</span>
          </span>
        </li>
        <li className="active">
          <span>
            <i className="sr-only">2단계 현재단계</i>
            <span className="step-tit">중복가입 확인</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">3단계</i>
            <span className="step-tit">약관동의</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">4단계</i>
            <span className="step-tit">정보입력</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">5단계</i>
            <span className="step-tit">사용자 가입 완료</span>
          </span>
        </li>
      </ol>

      <h3 className="content-tit">중복가입 확인</h3>
      <p className="text-gray-70">
        중복가입 확인을 위해 사업자 등록 번호를 확인하신 후 사용자 가입을
        진행하실 수 있습니다.
      </p>

      <div className="txt-box bg-white gap-md">
        <fieldset>
          <legend>중복가입 확인 폼</legend>
          <div className="form-group">
            <div className="form-tit">
              <label>사업자 등록 번호</label>
            </div>
            <div className="form-conts">
              <div className="input-group">
                <label className="hidden-label" htmlFor="brNoF">
                  라벨
                </label>
                <NumericFormat
                  type="text"
                  id="brNoF"
                  className="form-control"
                  value={formData.brNoF || ''}
                  onChange={handleInputChange}
                  thousandSeparator={false}
                  allowNegative={false}
                  maxLength={3}
                  allowLeadingZeros={true}
                />
                <span>-</span>
                <label className="hidden-label" htmlFor="brNoS">
                  라벨
                </label>
                <NumericFormat
                  type="text"
                  id="brNoS"
                  className="form-control"
                  value={formData.brNoS || ''}
                  onChange={handleInputChange}
                  thousandSeparator={false}
                  allowNegative={false}
                  maxLength={2}
                  allowLeadingZeros={true}
                />
                <span>-</span>
                <label className="hidden-label" htmlFor="brNoT">
                  라벨
                </label>
                <NumericFormat
                  type="text"
                  id="brNoT"
                  className="form-control"
                  value={formData.brNoT || ''}
                  onChange={handleInputChange}
                  thousandSeparator={false}
                  allowNegative={false}
                  maxLength={5}
                  allowLeadingZeros={true}
                />
                <button
                  type="button"
                  className="btn secondary"
                  onClick={() => {
                    fnDplChk();
                  }}
                >
                  중복 확인
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};

export default EntJoinBRNO;
